module.exports = __webpack_public_path__ + "static/media/seguradora_sompo.e69d44d8.jpg";